(function() {
    'use strict';

    angular.module('app').controller('PuescCtrl', [
        '$scope',
        '$q',
        '$http',
        '$translate',
        '$ngConfirm',
        'toaster',
        '$interval',
        'GoogleMapService',
        'uiGmapIsReady',
        '$stateParams',
        function(
            $scope,
            $q,
            $http,
            $translate,
            $ngConfirm,
            toaster,
            $interval,
            GoogleMapService,
            uiGmapIsReady,
            $stateParams
        ) {
            var puescType = $stateParams.puescType;

            $scope.isGeoSentMode = function() {
                return puescType === 'geosent';
            };

            $scope.isTollMode = function() {
                return !$scope.isGeoSentMode();
            };

            $scope.getSystemMode = function() {
                return $scope.isGeoSentMode() ? 'sent' : 'toll';
            };

            $scope.getIsSystemMode = function() {
                return $scope.isGeoSentMode() ? 'is_sent' : 'is_toll';
            };

            var $ctrl = this;
            var endpoint = `/rest-api/ms/puesc/api/notification/${$scope.getSystemMode()}`;

            $scope.notifications = {
                loaded: false,
                on: false,
                configuration: {
                    email: '',
                    phone: '',
                },
            };

            loadNotificationSettings();

            $scope.LIST_TAB = 'vehicles';
            $scope.HISTORY_TAB = 'history';

            $scope.changeTab = function(v) {
                $scope.tab = v;
            };

            $scope.isTab = function(tab) {
                return $scope.tab === tab;
            };

            $scope.tab = $scope.LIST_TAB;

            $ctrl.objects = [];

            $scope.puesc = {
                list: [],
                objects: _limitAvailableObjects([]),
                selected: null,
                histories: [],
            };

            $scope.filters = {
                objects: {
                    search: null,
                },
            };

            $scope.openFormModal = openFormModal;
            $scope.openCommentEditionModal = openCommentEditionModal;
            $scope.openInformationModal = openInformationModal;
            $scope.openDocumentsModal = openDocumentsModal;
            $scope.openHistoryModal = openHistoryModal;
            $scope.openNotificationModal = openNotificationModal;

            $scope.togglePuescObjectField = togglePuescObjectField;
            $scope.toggleNotificationStatus = toggleNotificationStatus;

            $scope.hasPuescObjectStatus = function(object, statuses) {
                return statuses.indexOf(object.status) >= 0;
            };

            $scope.hasPuescObjectActivated = function(object) {
                if (!$scope.hasPuescObjectStatus(object, [2])) {
                    return false;
                }

                return $scope.isGeoSentMode() ? object.is_sent : object.is_toll;
            };

            $scope.hasSentActivated = function(object) {
                return $scope.hasPuescObjectStatus(object, [1]) && object.is_sent;
            };

            $scope.sort = {
                reverse: null,
                call: function() {
                    switch ($scope.sort.reverse) {
                        case null:
                            $scope.sort.reverse = false;
                            $scope.sort.class = 'glyphicon-sort-by-attributes-alt';

                            break;
                        case false:
                            $scope.sort.reverse = true;
                            $scope.sort.class = 'glyphicon-sort-by-attributes';

                            break;
                        default:
                            $scope.sort.reverse = null;
                            $scope.sort.class = 'glyphicon-sort';
                    }
                },
                class: 'glyphicon-sort',
            };

            function _limitAvailableObjects(list) {
                return $ctrl.objects.filter(function(o) {
                    return list.indexOf(o.objectId) < 0;
                });
            }

            function _groupObjectsByDriver() {
                var objects = angular.copy($scope.extractObjectsBySelectedGroup(true, false));
                var results = [];

                var ids = objects.map(function(o) {
                    return o.objectId;
                });

                return $http
                    .post('/rest-api/ms/puesc/api/main/modules', { id: ids, isTollMode: $scope.isTollMode() })
                    .then(
                        function(response) {
                            var response = response.data;

                            for (var i in response) {
                                var item = response[i];
                                var founded = objects.find((o) => o.objectId === item.ObjectId);

                                if (!founded) {
                                    continue;
                                }

                                founded.Module = item;
                                results.push(founded);
                            }

                            return results;
                        },
                        function() {}
                    );
            }

            function togglePuescObjectField(object, field) {
                if ($scope.isTollMode()) {
                    var tollObjectDriverIds = $ctrl.objects.map(function(o) {
                        return o.objectId;
                    });

                    if (tollObjectDriverIds.indexOf(object.object_id) < 0) {
                        toaster.error(
                            $translate.instant('general.toastr.error.header'),
                            $translate.instant('puesc.toastr.error.wrong-driver')
                        );

                        return false;
                    }
                }

                var payload = {};
                payload[field] = !object[field];

                return updatePuescObject(object.id, payload);
            }

            function handleModificationError(error) {
                if (error.status !== 406) {
                    return;
                }

                toaster.error(
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('puesc.toastr.error.deactivating')
                );
            }

            function confirmSelectedOperation(cb) {
                $ngConfirm({
                    title: $translate.instant('puesc.confirm.title'),
                    content: $translate.instant('puesc.confirm.content'),
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-road',
                    buttons: {
                        no: {
                            text: $translate.instant('general.confirm.delete.no'),
                            btnClass: 'btn-dark',
                        },
                        yes: {
                            text: $translate.instant('general.confirm.delete.yes'),
                            btnClass: 'btn-danger',
                            action: function() {
                                return cb();
                            },
                        },
                    },
                });
            }

            function loadPuescObjects() {
                return $http
                    .get('/rest-api/ms/puesc/api/main')
                    .then(function(response) {
                        return response.data || [];
                    })
                    .then(function(data) {
                        $scope.puesc.objects = _limitAvailableObjects(
                            data.map(function(o) {
                                return o.object_id;
                            })
                        );

                        return data;
                    })
                    .then(function(data) {
                        $scope.puesc.list = data;

                        return $scope.puesc.list;
                    });
            }

            function loadNotificationSettings() {
                return $http.get(endpoint).then(function(response) {
                    var data = response.data;

                    if (data) {
                        $scope.notifications = {
                            loaded: true,
                            on: data.on,
                            configuration: data.configuration,
                        };
                    }
                });
            }

            function buildPayload(form) {
                if (!form.object) {
                    toaster.error(
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('puesc.toastr.error.object')
                    );
                    return false;
                }

                if (!form.custom) {
                    toaster.error(
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('puesc.toastr.error.custom')
                    );
                    return false;
                }

                return {
                    object_id: form.object.objectId,
                    custom: form.custom,
                    is_sent: form.is_sent,
                    is_toll: form.is_toll,
                };
            }

            function savePuescObject(payload) {
                return $http.post('/rest-api/ms/puesc/api/main', payload).then(
                    function() {
                        return loadPuescObjects();
                    },
                    function(error) {
                        if ([409, 500, 503].indexOf(error.status) >= 0) {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc.toastr.error.' + error.status)
                            );
                        }

                        return error;
                    }
                );
            }

            function updatePuescObject(id, payload) {
                return confirmSelectedOperation(function() {
                    return $http.put(`/rest-api/ms/puesc/api/main/${id}`, payload).then(function() {
                        loadPuescObjects();
                    }, handleModificationError);
                });
            }

            function _loadPuescObjectHistory(id, start, end) {
                var url = `/rest-api/ms/puesc/api/etoll/history/${id}`;

                if ($scope.isGeoSentMode()) {
                    url = `/rest-api/ms/puesc/api/sent/history/${id}`;
                }

                return $http
                    .get(url, {
                        params: {
                            start: start,
                            end: end,
                        },
                        timeout: 60000,
                    })
                    .then(function(response) {
                        return response.data || [];
                    });
            }

            function _loadPuescDocuments(id) {
                return $http.get(`/rest-api/ms/puesc/api/main/${id}/documents`).then(function(response) {
                    return response.data || [];
                });
            }

            function openFormModal() {
                var $isolated = $scope.$new(true);

                $isolated.objects = $scope.puesc.objects;

                $isolated.isTollMode = $scope.isTollMode;
                $isolated.isGeoSentMode = $scope.isGeoSentMode;

                $isolated.form = {
                    object: null,
                    custom: null,
                    is_sent: false,
                    is_toll: false,
                    active: true,
                };

                if ($scope.isGeoSentMode()) {
                    $isolated.form.is_sent = true;
                }

                if ($scope.isTollMode()) {
                    $isolated.form.is_toll = true;
                }

                $isolated.initial = angular.copy($isolated.form);

                $ngConfirm({
                    title: $translate.instant('puesc.modals.form.title'),
                    contentUrl: 'tpl/pages/puesc/modals/form.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-road',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                var payload = buildPayload(scope.form);

                                if (payload) {
                                    return savePuescObject(payload);
                                }

                                $isolated.form = angular.copy($isolated.initial);

                                return false;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function openCommentEditionModal(row) {
                var $isolated = $scope.$new(true);

                if (!row.module) {
                    return false;
                }

                $isolated.id = row.object_id;
                $isolated.form = {
                    comment: row.module.Comment,
                };

                $ngConfirm({
                    title: $translate.instant('puesc.modals.comment.title'),
                    contentUrl: 'tpl/pages/puesc/modals/comment.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-pen pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                $http.put(`/rest-api/vehicle/${scope.id}`, scope.form).then(
                                    function() {
                                        row.module.Comment = scope.form.comment;

                                        return true;
                                    },
                                    function() {
                                        toaster.pop(
                                            'error',
                                            $translate.instant('general.toastr.error.header'),
                                            $translate.instant('general.toastr.error.form.action.update')
                                        );
                                    }
                                );
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function openInformationModal(object) {
                var $isolated = $scope.$new(true);
                $isolated.object = object;

                $ngConfirm({
                    title: $translate.instant('puesc.modals.information.title'),
                    contentUrl: 'tpl/pages/puesc/modals/information.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-info-circle',
                    scope: $isolated,
                    buttons: {
                        cancel: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function openDocumentsModal(object) {
                var $isolated = $scope.$new(true);

                _loadPuescDocuments(object.id).then(function(data) {
                    $isolated.documents = data;
                });

                $ngConfirm({
                    title: $translate.instant('puesc.modals.documents.title'),
                    contentUrl: 'tpl/pages/puesc/modals/documents.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'fas fa-file-contract',
                    scope: $isolated,
                    buttons: {
                        cancel: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function openNotificationModal() {
                var $isolated = $scope.$new(true);

                $isolated.form = {
                    configuration: $scope.notifications.configuration,
                };

                return $ngConfirm({
                    title: $translate.instant('puesc.modals.notification.title'),
                    contentUrl: 'tpl/pages/puesc/modals/notification.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-pen pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                if (!scope.notificationForm.$valid) {
                                    toaster.pop(
                                        'error',
                                        $translate.instant('general.toastr.error.header'),
                                        $translate.instant('general.toastr.error.form.action.update')
                                    );

                                    return false;
                                }

                                var payload = {
                                    configuration: scope.form.configuration,
                                };

                                return $http.put(endpoint, payload).then(
                                    function(response) {
                                        var data = response.data;

                                        if (data) {
                                            $scope.configuration = data.configuration;
                                        }

                                        return true;
                                    },
                                    function() {
                                        toaster.pop(
                                            'error',
                                            $translate.instant('general.toastr.error.header'),
                                            $translate.instant('general.toastr.error.form.action.update')
                                        );

                                        return false;
                                    }
                                );
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            }

            function toggleNotificationStatus() {
                var payload = {
                    status: !$scope.notifications.on ? 1 : 0,
                };

                return $http.put(endpoint, payload).then(function(response) {
                    var data = response.data;

                    if (data) {
                        $scope.notifications.on = !!data.status;
                    }
                });
            }

            function openHistoryModal(object) {
                var $isolated = $scope.$new(true);

                var overlays = [];
                var loaded = false;

                $isolated.map = GoogleMapService.defaults(['cluster']);
                $isolated.start = moment()
                    .subtract(1, 'hours')
                    .format('YYYY-MM-DD HH:mm:ss');
                $isolated.end = moment().format('YYYY-MM-DD HH:mm:ss');

                $isolated.loading = true;
                $isolated.object = object;

                $isolated.csv = function() {
                    var content = 'data:text/csv;charset=utf-8,';
                    var rows = [['technical', 'geolocator', 'service', 'created', 'start', 'end']];

                    rows.push([
                        object.configuration.technical,
                        object.result.geolocatornumber,
                        object.result.obeservicenumber,
                        object.result.creationdate,
                        $isolated.start,
                        $isolated.end,
                    ]);

                    for (var i = 0; i < rows.length; i++) {
                        var row = rows[i];

                        row = row.join(',');
                        content += row + '\r\n';
                    }

                    content += '\r\n';
                    content += '\r\n';

                    rows = [['start', 'end', 'created', 'status', 'error', 'counting', 'coords']];

                    for (var i = 0; i < $isolated.history.length; i++) {
                        var entity = $isolated.history[i];

                        if (entity) {
                            rows.push([
                                entity.start,
                                entity.end,
                                entity.created,
                                entity.status,
                                entity.error,
                                entity.counting,
                                JSON.stringify(entity.coords),
                            ]);
                        }
                    }

                    for (var i = 0; i < rows.length; i++) {
                        var row = rows[i];

                        row = row.join(',');
                        content += row + '\r\n';
                    }

                    var filename = object.result.geolocatornumber + '-' + Date.now();
                    var encodedUri = encodeURI(content);

                    var link = document.createElement('a');
                    link.setAttribute('href', encodedUri);
                    link.setAttribute('download', filename + '.csv');

                    link.click();

                    angular.element('.angular-google-map .gmnoprint, .angular-google-map .gm-control-active').hide();

                    html2canvas(angular.element('.angular-google-map')[0], {
                        useCORS: true,
                        optimized: false,
                        allowTaint: false,
                    }).then(function(canvas) {
                        link = document.createElement('a');
                        link.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
                        link.download = filename + '.jpg';
                        link.click();

                        angular
                            .element('.angular-google-map .gmnoprint, .angular-google-map .gm-control-active')
                            .not('.gm-tilt')
                            .show();
                    });
                };

                $isolated.search = function() {
                    $isolated.loading = true;

                    for (var i = 0; i < overlays.length; i++) {
                        overlays[i].setMap(null);
                    }
                    overlays.splice(0, overlays.length);

                    eTollLoad(object.id, $isolated.start, $isolated.end);
                };

                function eTollLoad(id, start, end) {
                    _loadPuescObjectHistory(id, start, end)
                        .then(function(data) {
                            $isolated.history = data;

                            var promise = loaded ? $q.resolve() : uiGmapIsReady.promise();

                            promise.then(function() {
                                GoogleMapService.reset();
                                GoogleMapService.set($isolated.map);

                                loaded = true;

                                var fixed = [];
                                var points = data
                                    .slice()
                                    .reverse()
                                    .reduce(function(prev, curr) {
                                        var set = Object.assign({}, curr.coords);
                                        var coords = [];

                                        if (curr.fix !== void 0 && curr.fix !== null) {
                                            var fixset = Object.assign({}, curr.fix);

                                            fixed.push(
                                                Object.keys(fixset).map(function(key) {
                                                    return {
                                                        lat: fixset[key][0],
                                                        lng: fixset[key][1],
                                                    };
                                                })
                                            );
                                        }

                                        for (var key in set) {
                                            coords.push({
                                                lat: set[key][0],
                                                lng: set[key][1],
                                                key: key,
                                                point: {
                                                    counting: curr.counting,
                                                    start: curr.start,
                                                    end: curr.end,
                                                },
                                            });
                                        }

                                        return prev.concat(coords);
                                    }, []);

                                /**
                                 * extra sorting length test
                                 *
                                 * 10 -  timestamp
                                 * 11 =< message id
                                 */

                                if (points.length > 0) {
                                    if (String(points[0].key).length === 10) {
                                        points.sort(function(a, b) {
                                            return a.key >= b.key ? 1 : -1;
                                        });
                                    }
                                }

                                for (var i = 0; i < fixed.length; i++) {
                                    var parts = fixed[i];

                                    for (var j = 0; j < parts.length - 1; j++) {
                                        var ov = new google.maps.Polyline({
                                            path: [parts[j], parts[j + 1]],
                                            geodesic: true,
                                            strokeColor: '#00FF00',
                                            strokeOpacity: 0.8,
                                            strokeWeight: 10,
                                        });

                                        ov.setMap(GoogleMapService.get());
                                        overlays.push(ov);
                                    }
                                }

                                for (var i = 0; i < points.length - 1; i++) {
                                    var color = '#EA4335';

                                    if (points[i].point.counting > 5) {
                                        color = '#FBBC05';
                                    }
                                    if (points[i].point.counting > 10) {
                                        color = '#34A853';
                                    }

                                    var icon =
                                        i === points.length - 2
                                            ? [
                                                  {
                                                      icon: {
                                                          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                                          scale: 2,
                                                          strokeColor: '#00adef',
                                                          strokeOpacity: 1,
                                                          strokeWeight: 2,
                                                          fillColor: '#00adef',
                                                          fillOpacity: 1,
                                                      },
                                                  },
                                              ]
                                            : [];

                                    var ov = new google.maps.Polyline({
                                        path: [points[i], points[i + 1]],
                                        strokeColor: color,
                                        point: points[i].point,
                                        icons: icon,
                                    });

                                    var _hpclick = function(polyline) {
                                        toaster.info(
                                            $translate.instant(polyline.point.counting),
                                            $translate.instant(polyline.point.start + ' - ' + polyline.point.end)
                                        );
                                    };

                                    google.maps.event.addListener(ov, 'click', function(e) {
                                        _hpclick(this);
                                    });

                                    ov.setMap(GoogleMapService.get());
                                    overlays.push(ov);
                                }

                                GoogleMapService.extend(points);
                                uiGmapIsReady.reset();

                                $isolated.loading = false;
                            });
                        })
                        .catch(function() {
                            $isolated.loading = false;

                            toaster.pop(
                                'error',
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('puesc.toastr.error.timeout')
                            );
                        });
                }

                eTollLoad(object.id, $isolated.start, $isolated.end);

                var $dialog = $ngConfirm({
                    title: $translate.instant('puesc.modals.history.title'),
                    contentUrl: 'tpl/pages/puesc/modals/history.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'xlarge',
                    icon: 'fas fa-history',
                    scope: $isolated,
                    buttons: {
                        cancel: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });

                $isolated.cancel = function() {
                    $dialog.close();
                };
            }

            var interval = null;

            $scope.$on('$destroy', function() {
                $interval.cancel(interval);
            });

            function startInterval() {
                interval = $interval(function() {
                    return loadPuescObjects();
                }, 60000);
            }

            function init() {
                return _groupObjectsByDriver()
                    .then(function(response) {
                        $ctrl.objects = response;
                    })
                    .then(function() {
                        loadPuescObjects().then(function() {
                            return startInterval();
                        });
                    });
            }

            init();
        },
    ]);

    angular.module('app').filter('PuescOrderBy', function() {
        return function(items, system, reverse) {
            if (reverse === null) {
                return items;
            }

            return items.sort(function(a, b) {
                const first = a.integration[system].last;
                const second = b.integration[system].last;

                if (!first) {
                    return 1;
                }

                if (!second) {
                    return -1;
                }

                if (reverse) {
                    return new Date(first) - new Date(second);
                }

                return new Date(second) - new Date(first);
            });
        };
    });
})();
